"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Used to adjust your main page content to take a fixed
 * global header into account.
 *
 * This component will inject the correct CSS class into
 * an existing element. To use it simple wrap your root
 * content element like this:
 *
 * ```js
 * <GlobalHeaderAdjust fixed>
 *   <main>
 *     ...your content here
 *   </main>
 * </GlobalHeaderAdjust>
 * ```
 */


var GlobalHeaderAdjust = function (_React$Component) {
  _inherits(GlobalHeaderAdjust, _React$Component);

  function GlobalHeaderAdjust() {
    _classCallCheck(this, GlobalHeaderAdjust);

    return _possibleConstructorReturn(this, (GlobalHeaderAdjust.__proto__ || Object.getPrototypeOf(GlobalHeaderAdjust)).apply(this, arguments));
  }

  _createClass(GlobalHeaderAdjust, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          className: (0, _classnames2.default)({
            "mdc-toolbar-fixed-adjust": _this2.props.fixed
          }, child.props.className)
        });
      });
    }
  }]);

  return GlobalHeaderAdjust;
}(_react2.default.Component);

GlobalHeaderAdjust.propTypes = {
  /** Set to `true` when using a fixed global header. */
  fixed: _propTypes.bool
};
GlobalHeaderAdjust.defaultProps = {
  fixed: true
};
exports.default = GlobalHeaderAdjust;